import axios from "axios"
import store from "../store"

// API Server
const apiServer = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
})

// 全局設定 AJAX Request 攔截器 (interceptor)
apiServer.interceptors.request.use(
  config => {
    const token = store.getters["auth/getJWT"]
    token && (config.headers.Authorization = "Bearer " + token)
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 全局設定 AJAX Response 攔截器 (interceptor)
apiServer.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      const response = error.response
      return Promise.reject(response)
    }
  }
)

export const API = {
  Check: data => apiServer.post("UserQuery", data),
}
